import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=71cc98f8&"
import script from "./Register.vue?vue&type=script&lang=ts&"
export * from "./Register.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports